const $$splitComponentImporter = () => import('/Users/vthang/projects/marvy_mono/apps/pinktool/src/routes/_app/coupons.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import type { Coupon } from "@/api/types.gen";
export const Route = createFileRoute("/_app/coupons")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface CouponFormData {
  name: string;
  code: string;
  type: "percentage" | "amount";
  amount: number;
  quantity: number;
  rule: "single" | "multiple";
  no_expire: boolean;
  expire_at: string;
  valid_from: string;
}
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}